import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { CONTACT_EMAIL_PATTERN } from "src/libs/portal/season/contact-policy";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageAccessComponent implements OnInit {
    public view: string = 'login';
    public loading: boolean = false;

    public loginData: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        email: '',
        mobile: '',
        password: '',
        passwordConfirm: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(location.search);
        this.view = params.get('view') === 'signup' ? 'signup' : 'login';

        let check = await this.service.auth.check();
        if (check) return location.href = "/market";
        await this.service.render();
    }

    public get heading() {
        return this.view === 'signup' ? '회원가입' : '로그인';
    }

    public get formTitle() {
        return this.view === 'signup' ? '회원가입' : '로그인';
    }

    public get formDescription() {
        return this.view === 'signup'
            ? '회원 정보를 입력하면 바로 서비스를 이용할 수 있습니다.'
            : '등록된 이메일과 비밀번호를 입력하세요.';
    }

    public async setView(view: string) {
        this.view = view === 'signup' ? 'signup' : 'login';
        const url = this.view === 'signup' ? '/access?view=signup' : '/access';
        history.replaceState(null, '', url);
        await this.service.render();
    }

    public tabClass(view: string) {
        const base = 'inline-flex h-9 items-center justify-center rounded px-3 text-[13px] font-semibold transition-colors';
        if (this.view === view) return `${base} bg-white text-slate-950 shadow-sm`;
        return `${base} text-slate-500 hover:text-slate-900`;
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login(event?: Event) {
        if (event) event.preventDefault();
        if (this.loading) return;

        let user = JSON.parse(JSON.stringify(this.loginData));

        // 브라우저 자동완성은 화면의 input 값만 채우고 ngModel 갱신 이벤트를
        // 발생시키지 않는 경우가 있어, 제출 시점의 실제 폼 값을 기준으로 로그인한다.
        if (event && event.currentTarget instanceof HTMLFormElement) {
            const formData = new FormData(event.currentTarget);
            user.email = String(formData.get('email') || '');
            user.password = String(formData.get('password') || '');
            this.loginData.email = user.email;
            this.loginData.password = user.password;
        }

        user.email = (user.email || '').trim();

        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!this.isEmail(user.email)) {
            await this.alert("올바른 이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        this.loading = true;
        await this.service.render();

        let { code, data } = await wiz.call("login", user);
        this.loading = false;

        if (code == 200) {
            location.href = "/market";
            return;
        }

        await this.alert(this.errorMessage(data, "로그인에 실패했습니다."), 'error');
        await this.service.render();
    }

    public async signup() {
        let user = JSON.parse(JSON.stringify(this.signupData));
        user.name = (user.name || '').trim();
        user.email = (user.email || '').trim();
        user.mobile = (user.mobile || '').trim();

        if (!user.name) {
            await this.alert("회원명을 입력해주세요.");
            return;
        }
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!this.isEmail(user.email)) {
            await this.alert("올바른 이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if ((user.password.length < 8 || !user.password.trim() || new TextEncoder().encode(user.password).length > 72)) {
            await this.alert("비밀번호는 8자 이상, UTF-8 기준 72바이트 이내로 입력해 주세요.");
            return;
        }
        if (user.password !== user.passwordConfirm) {
            await this.alert("비밀번호 확인이 일치하지 않습니다.");
            return;
        }

        this.loading = true;
        await this.service.render();

        let { code, data } = await wiz.call("signup", user);
        this.loading = false;

        if (code == 200) {
            location.href = "/market";
            return;
        }

        await this.alert(this.errorMessage(data, "회원가입에 실패했습니다."), 'error');
        await this.service.render();
    }

    private isEmail(email: string) {
        return CONTACT_EMAIL_PATTERN.test(email);
    }

    private errorMessage(data: any, fallback: string) {
        if (!data) return fallback;
        if (typeof data === 'string') return data;
        return data.message || fallback;
    }
}

export default PageAccessComponent;